import { Button } from '@mui/material';
import { useDialogVisibilityHook } from 'src/hooks';
import TemporaryDialog from './temporary-dialog';

interface IModuleSaveButtonProps {
  onSave: () => Promise<unknown>;
  // eslint-disable-next-line react/require-default-props
  disabled?: boolean;
}

export default function ModuleSaveButton({
  onSave,
  disabled = false
}: IModuleSaveButtonProps) {
  const {
    isDialogOpen: isSavingScenarioDialogOpen,
    setDialogVisibility: setIsSavingScenarioDialogVisibility
  } = useDialogVisibilityHook();
  const {
    isDialogOpen: isSavingScenarioSuccessDialogOpen,
    setDialogVisibility: setScenarioSaveSuccessfulDialogVisibility
  } = useDialogVisibilityHook();

  const handleSave = () => {
    setIsSavingScenarioDialogVisibility(true);
    onSave()
      .then(() => {
        setIsSavingScenarioDialogVisibility(false);
      })
      // eslint-disable-next-line no-promise-executor-return
      .then(() => new Promise((resolve) => setTimeout(resolve, 500)))
      .then(() => {
        setScenarioSaveSuccessfulDialogVisibility(true);
      })
      // eslint-disable-next-line no-promise-executor-return
      .then(() => new Promise((resolve) => setTimeout(resolve, 2000)))
      .catch(() => {
        setIsSavingScenarioDialogVisibility(false);
        setScenarioSaveSuccessfulDialogVisibility(false);
      })
      .finally(() => {
        setScenarioSaveSuccessfulDialogVisibility(false);
      });
  };

  return (
    <>
      <Button
        disabled={disabled}
        sx={{ ml: 1 }}
        variant='contained'
        onClick={handleSave}
      >
        Save
      </Button>

      <TemporaryDialog
        isOpen={isSavingScenarioDialogOpen}
        imagePath='/static/images/upload-cloud.svg'
        message='Saving Scenario'
      />
      <TemporaryDialog
        isOpen={isSavingScenarioSuccessDialogOpen}
        imagePath='/static/images/success.svg'
        message='Scenario saved successfully'
      />
    </>
  );
}
